<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="memberCertBox">
          <!-- <img class="memberCertImg" src="" alt=""> -->
          <!-- 24.11.23 会员证书 dxm -->
          <div class="certificate-wrap" id="certificate" :style="{ maxWidth: vip_imageWidth + 'px' }">
            <!-- 个人会员证 -->
            <template v-if="type == 1">
              <div class="vip-card" :style="{ maxWidth: vip_imageWidth + 'px' }">
                <img class="card" :src="vipCard" alt="" @load="getCard"/>
                <img class="card-stamp" :src="stampImg" alt=""/>
                <div class="card-infor">
                  <img class="card-head" :src="cardInfo.head_photo" alt=""/>
                  <div class="card-div">
                    <div class="card-text">姓名：{{ cardInfo.full_name }}</div>
                    <div class="card-text">
                      会员编号：{{ cardInfo.member_code }}
                    </div>
                    <div class="card-text">身份证号：{{ cardInfo.IDCard }}</div>
                    <div class="card-text">
                      <div>
                        会内职务：
                        <span v-if="cardInfo.association_position!='无'">
                         {{ cardInfo.association_position }}
                      </span>
                        <span v-if="cardInfo.committee_position&&cardInfo.committee_position!='无'&&cardInfo.association_position!='无'">、</span>
                        <span v-if="cardInfo.committee_position!='无'">{{ cardInfo.committee_position }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-time">证件有效期：{{ cardInfo.create_time + ' 至 ' + cardInfo.due_time }}</div>
              </div>
            </template>
            <!-- 单位会员证 -->
            <template v-if="type == 2">
              <div class="unit-card" :style="{ maxWidth: imageWidth + 'px' }">
                <img class="card" :src="unitCard" alt="" @load="getCard"/>
                <img class="card-stamp" :src="stampImg" alt=""/>
                <div class="unit-company">{{ cardInfo.company_name }}</div>
                <div class="unit-infor">
                  <div class="unit-text">
                    <div>会员编号：{{ cardInfo.member_code }}</div>
                    <div>
                      会内职务：
                      <span v-if="cardInfo.association_position!='无'">
                         {{ cardInfo.association_position }}
                      </span>
                      <span v-if="cardInfo.committee_position&&cardInfo.committee_position!='无'&&cardInfo.association_position!='无'">、</span>
                      <span v-if="cardInfo.committee_position!='无'">{{ cardInfo.committee_position }}</span>
                    </div>
                    <div>证件有效期：{{ cardInfo.due_time }}</div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!--          <div class="certificate-wrap" v-if="">-->
          <!--          <div>您还不是正式会员</div>-->
          <!--          </div>-->
          <div class="footer">
            <div class="conf-btn flex">
              <!-- 可跳过需要验证 -->
              <template v-if="detail.is_skip == 1 && detail.is_verify == 1">
                <div class="btn" @click="next('skip')">跳过</div>
                <div class="btn next_btn" @click="next('next')">下一步</div>
              </template>
              <!-- 可跳过无需验证 -->
              <template v-if="detail.is_skip == 1 && detail.is_verify == 0">
                <div class="btn next_btn" @click="next('known')">已知悉</div>
              </template>
              <!-- 不可跳过需要验证 -->
              <template v-if="detail.is_skip == 0 && detail.is_verify == 1">
                <div class="btn next_btn" @click="next('next')">下一步</div>
              </template>
              <button class="btn next_btn" @click="down">下载</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  contactsLists,
  getmyMenu,
  skipOrReadStep,
  MembersDetail,
  MemberCertificate,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import html2canvas from "html2canvas";

export default {
  components: {top, navMenu},
  name: "attestation",
  data() {
    return {
      radio: 3,
      dialogVisible: false,
      loading: false,
      active: 2,
      mark: "",
      detail: {},
      // vipCard: require("../assets/vipcard.jpg"),
      // unitCard: require("../assets/unitcard.jpg"),
      // stampImg: require("../assets/stamp.jpg"),
      vipCard: '',
      unitCard: '',
      stampImg: '',
      type: 1,
      //会员证信息
      cardInfo: {},
      imageWidth: "600",
      vip_imageWidth: "800",
    };
  },
  mounted() {
    //   let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    // //   this.stepMenuList = stepMenuList;
    //   var index = stepMenuList.findIndex(function (item) {
    //     return item.link_url == "/memberCert";
    //   });
    //   this.active = index;
    this.id = this.$route.query.id;
    this.mark = this.$route.query.mark;
    this.getMenu();
    // this.getList(this.page_no);
    let userData = JSON.parse(localStorage.getItem("userdata"));
    this.type = userData.type;
    //24.11.23 获取会员信息 dxm
    this.getDetails();
    // 获取证书   印章  图片
    this.getMemberCertificate()
  },
  methods: {
    getMenu() {
      let that = this;
      let data = this.$qs.stringify({
        type: JSON.parse(localStorage.getItem("userdata")).type,
      });
      getmyMenu(data)
          .then((res) => {
            if (res.code == 1) {
              let {data} = res;
              this.stepMenuList = data;
              let stepMenuList = data;
              var index = stepMenuList.findIndex(function (item) {
                return item.link_url == "/memberCert";
              });
              that.detail = stepMenuList[index];
              if (
                  stepMenuList[index].children &&
                  stepMenuList[index].children.length > 0
              ) {
                that.list = stepMenuList[index].children;
              }
              // that.list[2].link_url="InvoiceManage"
              that.active = index;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    //    缴费说明
    payDescription() {
      this.dialogVisible = true;
    },
    //   付款信息
    toPayment() {
      this.$router.push({
        name: "paymentInfoList",
      });
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    getList(page_no) {
      let that = this;
      let data = that.$qs.stringify({
        page_no: page_no,
        page_size: that.page_size,
      });
      contactsLists(data)
          .then((res) => {
            if (res.code == 1) {
              console.log(res.data.lists, "res.data.lists");

              // that.tableData = res.data.lists;
              // that.total=Number(res.data.count);
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 获取证书图片地址
    getMemberCertificate() {
      MemberCertificate({})
          .then((res) => {
            if (res.code == 1) {
              this.vipCard = res.data.Individul
              this.unitCard = res.data.Company
              this.stampImg = res.data.seal
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 24.11.23 获取会员证宽高 dxm
    getCard(e) {
      const img = e.target;
      // this.imageWidth = img.naturalWidth;
    },
    //24.11.23 获取会员信息 dxm
    getDetails() {
      MembersDetail(this.$qs.stringify({type: this.type}))
          .then((res) => {
            if (res.code == 1) {
              let {data} = res;
              console.log(data, "====data");
              this.cardInfo = data;
              this.cardInfo.create_time = this.cardInfo.create_time.split(" ")[0];
              this.cardInfo.due_time = this.cardInfo.due_time.split(" ")[0];
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    //24.11.23 下载会员证 dxm
    down() {
      let that = this;
      that.loading = true;
      let image = that.type == 1 ? that.vipCard : that.unitCard;
      that.convertImageToBase64(image, that.base64CallBack);
      let certificateDOM = document.getElementById('certificate');
      html2canvas(certificateDOM, {
        width: certificateDOM.offsetWidth,
        height: certificateDOM.offsetHeight,
        //按比例增加分辨率
        scale: window.devicePixelRatio * 3, // 设备像素比
        useCORS: true, //（图片跨域相关）
        allowTaint: true, //允许跨域（图片跨域相关）
        logging: false,
        letterRendering: true,
      })
          .then(function (canvas) {
            let posterImgURL = canvas.toDataURL("image/png");
            let a = document.createElement("a");
            a.download = that.type == 1 ? "会员证" : "单位会员";
            a.href = posterImgURL;
            a.dispatchEvent(new MouseEvent("click"));
            that.loading = false;
            this.GetskipOrReadStep(2, true);
          })
          .catch((err) => {
            console.log(err, "err");
          });
    },
    //下载邀请函时，图片转base64
    convertImageToBase64(imgUrl, callback) {
      const image = new Image();
      image.crossOrigin = "Anonymous"; // 设置跨域属性
      image.src = imgUrl;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataUrl = canvas.toDataURL();
        callback && callback(dataUrl);
      };
      image.onerror = (error) => {
        console.error("图加载失败", error);
      };
    },
    // 分页相关
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getList(this.page_no);
    },

    // 跳转下一步
    next(type) {
      if (type == "next") {
        //下一步
        if (this.detail.action == 1 || this.detail.action == 4) {
          this.toPath();
        } else {
          this.$message.warning("请完善信息!");
        }
      } else if (type == "skip") {
        //跳过
        this.GetskipOrReadStep(1);
      } else if (type == "known") {
        //已知悉
        this.GetskipOrReadStep(2);
      }
    },
    // 跳过或者已知悉
    GetskipOrReadStep(action, yes) {
      let data = {
        type: JSON.parse(localStorage.getItem("userdata")).type,
        action,
        mark: this.detail.mark,
      };
      skipOrReadStep(data)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              if (yes) return false
              this.toPath();
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    toPath() {
      this.active = this.active + 1;
      let {link_url, menu_title, id} = this.stepMenuList[this.active];
      // if (link_url == "/exhibitorManual" || link_url == "/standPrepare") {
      //   this.$router.push({
      //     path: link_url
      //   });
      // } else {
      this.$router.push({
        path: link_url,
      });
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.memberCertImg {
  width: 100%;
  height: 731px;
}

.certificate-wrap {
  margin: 0 auto;
  padding-bottom: 22px;

  .vip-card {
    border: 1px solid #cccccc;
    position: relative;

    .card {
      width: 100%;
      display: block;
    }

    .card-infor {
      position: absolute;
      top: 40%;
      left: 33.3%;
      width: 80%;
      height: 24%;
      display: flex;
      align-items: flex-end;

      .card-head {
        width: 15%;
        height: 100%;
        background: yellow;
        margin-right: 4%;
      }

      .card-div {
        height: 70%;

        .card-text {
          font-size: 0.08rem;
          line-height: 0.14rem;
          font-family: "SimSun", "宋体", serif;
        }
      }
    }

    .card-time {
      position: absolute;
      bottom: 19%;
      left: 21%;
      font-size: 0.08rem;
      font-family: "SimSun", "宋体", serif;
    }

    .card-stamp {
      position: absolute;
      bottom: 4%;
      right: 12%;
      width: 23%;
    }
  }

  .unit-card {
    border: 1px solid #cccccc;
    margin: 0 auto;
    position: relative;

    .card {
      width: 100%;
      display: block;
    }

    .unit-company {
      position: absolute;
      top: 42%;
      left: 0;
      width: 100%;
      font-size: 0.2rem;
      text-align: center;
    }

    .unit-infor {
      position: absolute;
      top: 57%;
      left: 20%;

      .unit-text {
        font-size: 0.08rem;
        line-height: 0.15rem;
        font-family: "SimSun", "宋体", serif;
      }
    }

    .card-stamp {
      position: absolute;
      bottom: 15%;
      right: 18%;
      width: 27%;
    }
  }
}

.footer {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 37px;
}

.conf-btn {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);

  .btn {
    min-width: 128px;
    height: 36px;
    cursor: pointer;
    margin: 0 10px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 36px;
    text-align: center;
    background: #ffffff;
    border: 1px solid #cad2dd;
    border-radius: 9px;

    &:hover {
      text-decoration: underline;
    }
  }

  .next_btn {
    color: #fff;
    background: linear-gradient(90deg, #f27fc0 0%, #e40080 100%);
    border: none;
  }
}
</style>